// extracted by mini-css-extract-plugin
export default {"modalOverlay":"JA-z","modalContent":"KA-z","header":"LA-z","close":"MA-z"};